import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button } from '../components/Button';
import { H2 } from '../components/H2';
import { PhoneNumber } from '../components/PhoneNumber';
import { TextField } from '../components/TextField';
import { OrderHistoryQueryRequest } from '../types/types';
import { nonMemberOrderHistories } from '../apis/orders';
import { useHistory } from 'react-router-dom';
import { nToast } from '../plugins/reactToast';

export const NonMemberPage = () => {
  const form = useForm<OrderHistoryQueryRequest>();
  const [orderNumber, setOrderNumber] = useState<string>('');
  const history = useHistory();

  const getOrder = (data: OrderHistoryQueryRequest) => {
    nonMemberOrderHistories(orderNumber, data)
      .then(r => {
        localStorage.setItem('customerName', form.watch().customerName!);
        localStorage.setItem('customerPhone', form.watch().customerPhone!);
        return history.push(`/non-member/${orderNumber}`, {
          order: r.data.payload,
        });
      })
      .catch(e =>
        nToast('입력하신 정보가 일치하지 않습니다. 고객센터에 문의해 주세요.'),
      );
  };

  return (
    <div className="px-4 max-w-md mx-auto">
      <H2 className="font-semibold text-center md:py-10 pt-10 pb-4">
        비회원 주문조회
      </H2>

      <div className="bg-gray-50 text-14 p-5 space-y-2 mb-8">
        <p className="text-gray-500">주문번호 분실 시 아래로 문의주세요.</p>
        <p className="">
          02-541-0854 <br />
          mon - fri : 9:30 - 17:30
          <br />
          break : 12:30 - 13:30
        </p>
      </div>

      <form
        className="flex flex-col space-y-6"
        onSubmit={form.handleSubmit(getOrder)}>
        <TextField
          label="이름"
          placeholder="이름을 입력해주세요."
          {...form.register('customerName', {
            required: '이름을 입력해주세요.',
          })}
        />

        <PhoneNumber
          label="핸드폰 번호"
          onChange={e => form.setValue(`customerPhone`, e.target.value)}
        />

        <TextField
          label="주문번호"
          placeholder="주문번호를 입력해주세요."
          onChange={e => setOrderNumber(e.target.value)}
        />

        <Button type="submit" text="주문 조회하기" className="filled-brand-1" />
      </form>
    </div>
  );
};
